<accordion-body>
    <div class="{ state.closed ? 'hidden' : 'block' }">
         <slot />
    </div>

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {
            onBeforeMount(props, state) {
                this.state = {
                    closed: false
                }
                eventBus.on(EVENTS.UI.TOGGLE_ACCORDION, this.handleToggleAccordion)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.UI.TOGGLE_ACCORDION, this.handleToggleAccordion)
            },

            handleToggleAccordion(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        closed: e.closed
                    })
                }
            }
        }
    </script>
</accordion-body>
